import React from "react";
import "./style.css";
import {PAYMENT_TYPE_STRIPE} from "../../../../../../../const/Pay";
import Stripe from "../../../../../../../components/Stripe";
import { Image } from "../../../../../../../components/Image";

export const PcPayMethodsPopup = (props) => {
  const { showPopup, clickPaypalPay, closePaymentPopup, price } = props;
  const planTitle = price.dynamicCycleSubscription
    ? `${price.week}-Week Trial`
    : `${price.getFinalWeek()}-Week Plan`;
  const originPrice = price.getOriginPrice();
  const currentPrice = price.getPrice();
  const showOriginPrice = !!originPrice && originPrice !== currentPrice;

  return (
    <div className="pay-methods-popup-pc" style={{display: showPopup ? "" : "none"}}>
      <div className="popup-card">
        <div className="popup-header">
          <div className="popup-title">Select payment method</div>

          <div className="popup-close" onClick={closePaymentPopup}>
            <div className="popup-close-icon-wrap">
              <Image
                src="/static/image/questionnaire/weight-loss/pay-methods-popup/pc/icons-clear-24px.svg"
                alt="Icons clear"
                className="popup-close-icon"
              />
            </div>
          </div>
        </div>

        <div className="popup-body">
          <div className="popup-summary-panel">
            <div className="popup-summary-image-wrap">
              <Image
                src="/static/image/questionnaire/weight-loss/payMethodsPopup/price-info-image.jpg"
                alt={planTitle}
                className="popup-summary-image"
              />
            </div>

            <div className="popup-summary-text">
              <div className="popup-summary-title">{planTitle}</div>
              <div className="popup-summary-prices">
                {showOriginPrice && <div className="popup-summary-origin">{originPrice}</div>}
                <div className="popup-summary-current">{currentPrice}</div>
              </div>
            </div>
          </div>

          <div className="contents">
            <div className="frame-4">
              <div className="bottom" onClick={clickPaypalPay}>
                <Image
                  src="/static/image/questionnaire/weight-loss/pay-methods-popup/pc/create-a-custom-paypal-logo-and-buttons-paypal-in-1.svg"
                  alt="PayPal"
                  className="create-a-custom"
                />
              </div>

              <p className="text-wrapper-5">The safer, easier way to pay</p>
            </div>

            <div className="or">
              <div className="frame-5">
                <Image src="/static/image/questionnaire/weight-loss/pay-methods-popup/pc/line.svg" alt="Line" className="line" />

                <p className="text-wrapper-6">or pay with a card</p>

                <Image src="/static/image/questionnaire/weight-loss/pay-methods-popup/pc/line-1.svg" alt="Line" className="line" />
              </div>
            </div>

            <div className="frame-6">
              <Stripe
                price={price}
                paymentType={PAYMENT_TYPE_STRIPE}
                {...props}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
